/**
 * Standard validation banner — surfaces blocking validation issues
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC } from 'react';
import { AlertTriangle } from 'lucide-react';

import type { ValidationIssue } from './utils';

export interface StandardValidationBannerProps {
  issues: ValidationIssue[];
}

const StandardValidationBanner: FC<StandardValidationBannerProps> = ({
  issues,
}) => {
  if (issues.length === 0) return null;
  return (
    <div className="flex items-start gap-2 rounded-md border border-warning/40 bg-warning/10 p-3 text-sm text-warning">
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />
      <div className="min-w-0 flex-1 space-y-1">
        <p className="font-semibold">
          Resolve {issues.length} issue{issues.length === 1 ? '' : 's'} before applying
        </p>
        <ul className="space-y-0.5 text-xs">
          {issues.slice(0, 5).map((issue) => (
            <li key={`${issue.path}-${issue.message}`} className="font-mono">
              <span className="text-warning/80">{issue.path}</span>
              <span className="ml-2">{issue.message}</span>
            </li>
          ))}
          {issues.length > 5 && (
            <li className="italic">…and {issues.length - 5} more</li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default StandardValidationBanner;
